import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';

// draft-js is a large dependency and flow-web generally ends up in the
// root bundle, so only exposing the code-split tagged input will keep
// draft-js in a lazy-loaded chunk

export var _AsyncTaggedInput = /*#__PURE__*/function (_React$Component) {
  function _AsyncTaggedInput() {
    var _this;
    _classCallCheck(this, _AsyncTaggedInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _AsyncTaggedInput, [].concat(args));
    _defineProperty(_this, "state", {
      loaded: !!_AsyncTaggedInput.TaggedInput
    });
    return _this;
  }
  _inherits(_AsyncTaggedInput, _React$Component);
  return _createClass(_AsyncTaggedInput, [{
    key: "render",
    value: function render() {
      if (!this.state.loaded) {
        return null;
      }
      return /*#__PURE__*/React.createElement(_AsyncTaggedInput.TaggedInput, _extends({}, this.props, {
        ref: this.props.forwardRef
      }));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      if (!this.state.loaded) {
        import('./TaggedInput').then(function (m) {
          _AsyncTaggedInput.TaggedInput = m.TaggedInput;
          _this2.setState({
            loaded: true
          });
        });
      }
    }
  }]);
}(React.Component);
_defineProperty(_AsyncTaggedInput, "TaggedInput", void 0);
/** @deprecated This component should be forked to wherever it's used */
export var AsyncTaggedInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(_AsyncTaggedInput, _extends({}, props, {
    forwardRef: ref
  }));
});